import companyMaintain from './company-maintain'

export default {
  namespaced: true,
  modules: {
    companyMaintain,
  },
}
